export default __webpack_public_path__ + "static/media/calls-square-zoom.40935143.jpg";